module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAsCAMAAACngONPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF2eri0+bd6+vr2tvbzd3V6fPt+/z7ydHN4u/nytjR9Pb14eHiz+HY0dHR////3u7p1I1fogAAAOJJREFUeNqc1I0OhCAIAGAgU/x//7c9Mc+l6W4dW2v6hckcQnqEPp28oA3dycwZABAx55uckG8BTbhkDNAFEUbI2GSaFtEt5yH5vMS+Ed6ulrcCl6itLHJwV08taC2y7SKEb4SruHVBG4FLwlbUsiCp9pWUbb8X/iGrSuEPwbUoY8NSwMR4VJmPLsQSVXgS22XOMaSdLsI8d0LUtReGpUCOSh212cbWCVFhMH4WsNbIvyOlabW6JQl9yYGgrDFWKZn08qQm0cQePpGn1OUbh9P3CwOoC41XCWjvqXyraYL0EWAA6s04h3JzeUMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/IN.png
// module id = UPFU
// module chunks = 1